/**
 * Menu drawer sync + homepage scroll header reveal.
 * Does not change first-load transparent header styling.
 */
(function () {
  const MENU_ID = 'header-sidebar-menu';
  const REVEAL_AT = 20;

  function getStoreHeader() {
    return document.querySelector('store-header.header');
  }

  function getScrollY() {
    var y = window.isopureLenis && typeof window.isopureLenis.scroll === 'number'
      ? window.isopureLenis.scroll
      : window.scrollY || document.documentElement.scrollTop || 0;
    return Math.max(0, Math.round(y));
  }

  function isHomepage() {
    return document.body.classList.contains('template-index') &&
      Boolean(document.querySelector('[allow-transparent-header]'));
  }

  function isMenuOpen() {
    var menu = document.getElementById(MENU_ID);
    return Boolean(menu && menu.hasAttribute('open'));
  }

  function refreshLayoutVars() {
    var root = document.documentElement;
    var announcement = document.querySelector('.shopify-section--announcement-bar');
    var headerSection = document.querySelector('.shopify-section--header');

    if (announcement) {
      root.style.setProperty('--announcement-bar-height', '35px');
    }

    if (headerSection) {
      var hh = Math.round(headerSection.getBoundingClientRect().height);
      if (hh > 0) root.style.setProperty('--header-height', hh + 'px');
    }

    var s = getComputedStyle(root);
    var stickyArea =
      (parseFloat(s.getPropertyValue('--sticky-announcement-bar-enabled')) || 0) *
        (parseFloat(s.getPropertyValue('--announcement-bar-height')) || 0) +
      (parseFloat(s.getPropertyValue('--sticky-header-enabled')) || 0) *
        (parseFloat(s.getPropertyValue('--header-height')) || 0);

    if (stickyArea > 0) root.style.setProperty('--sticky-area-height', stickyArea + 'px');

    var menuTop = stickyArea;
    if (headerSection) {
      var headerBottom = Math.round(headerSection.getBoundingClientRect().bottom);
      if (headerBottom > menuTop) menuTop = headerBottom;
    }
    if (menuTop > 0) root.style.setProperty('--menu-drawer-top', menuTop + 'px');
  }

  function showFilledHeader() {
    var header = getStoreHeader();
    var headerSection = document.querySelector('.shopify-section--header');
    if (!header) return;

    header.classList.add('is-filled');
    header.style.transform = 'translateY(0)';
    if (headerSection) headerSection.style.visibility = 'visible';
  }

  function showTransparentHeader() {
    var header = getStoreHeader();
    if (!header || isMenuOpen()) return;

    header.classList.remove('is-filled');
    header.style.transform = '';
  }

  function syncScrollHeader() {
    if (isMenuOpen()) {
      showFilledHeader();
      var header = getStoreHeader();
      if (header) header.classList.add('is-menu-open');
      refreshLayoutVars();
      return;
    }

    if (!isHomepage() && !isCollectionWithBanner()) return;

    if (getScrollY() > REVEAL_AT) {
      showFilledHeader();
    } else {
      showTransparentHeader();
    }
  }

  function afterThemeScroll() {
    ensureInternalPageHeader();
    syncScrollHeader();
    requestAnimationFrame(function () {
      ensureInternalPageHeader();
      syncScrollHeader();
    });
  }

  function getMenuToggle() {
    return document.querySelector('[aria-controls="' + MENU_ID + '"]');
  }

  function openMenu() {
    document.documentElement.classList.add('nav-menu-open');
    document.documentElement.classList.remove('lock');
    var header = getStoreHeader();
    var toggle = getMenuToggle();
    if (header) {
      header.classList.add('is-menu-open', 'is-filled');
      header.style.transform = 'translateY(0)';
    }
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
      if (toggle.dataset.closeLabel) {
        toggle.setAttribute('aria-label', toggle.dataset.closeLabel);
      }
    }
    refreshLayoutVars();
    requestAnimationFrame(refreshLayoutVars);
  }

  function closeMenu() {
    document.documentElement.classList.remove('nav-menu-open');
    var header = getStoreHeader();
    var toggle = getMenuToggle();
    if (header) header.classList.remove('is-menu-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      if (toggle.dataset.menuLabel) {
        toggle.setAttribute('aria-label', toggle.dataset.menuLabel);
      }
    }
    afterThemeScroll();
  }

  function isCollectionWithBanner() {
    return document.body.classList.contains('template-collection') &&
      Boolean(document.querySelector('.shopify-section--collection-banner [allow-transparent-header]'));
  }

  function ensureInternalPageHeader() {
    if (isHomepage() || isCollectionWithBanner()) return;
    var header = getStoreHeader();
    if (!header) return;
    header.removeAttribute('allow-transparency');
    if (!isMenuOpen()) header.classList.add('is-filled');
  }

  function init() {
    var header = getStoreHeader();

    if (header && isHomepage()) {
      header.setAttribute('allow-transparency', '');
      if (getScrollY() <= REVEAL_AT) {
        header.classList.remove('is-filled', 'is-menu-open');
        header.style.transform = '';
      }
    } else {
      ensureInternalPageHeader();
    }

    var toggle = getMenuToggle();
    if (toggle && !toggle.dataset.menuLabel) {
      toggle.dataset.menuLabel = toggle.getAttribute('aria-label') || 'Menu';
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[aria-controls="' + MENU_ID + '"]');
      if (!toggle || toggle.getAttribute('aria-expanded') === 'true') return;
      openMenu();
    }, true);

    window.addEventListener('scroll', afterThemeScroll, { passive: true });
    document.addEventListener('isopure:scroll', afterThemeScroll);

    refreshLayoutVars();

    if (getScrollY() > REVEAL_AT) {
      afterThemeScroll();
    }
  }

  document.addEventListener('dialog:after-show', function (event) {
    if (event.target.id === MENU_ID) {
      openMenu();
      requestAnimationFrame(function () {
        document.documentElement.classList.remove('lock');
      });
    }
  });

  document.addEventListener('dialog:after-hide', function (event) {
    if (event.target.id === MENU_ID) closeMenu();
  });

  window.addEventListener('resize', function () {
    refreshLayoutVars();
    if (isMenuOpen()) openMenu();
    else afterThemeScroll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
